<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<h2>
					{{ 'company-details.view.pageTitle' | translate }}
				</h2>
				<eif-custom-breadcrumbs [breadcrumbItems]="breadcrumbItems"></eif-custom-breadcrumbs>
			</div>
		</div>
	</div>

	<div class="simple-card top-line p-5 d-grid gap-5">
		<div class="is-content-section">
			<div class="is-content-section-fields">
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.countryCode' | translate }}</p>
					<p class="is-value">{{ company?.CountryCode }} - {{ company?.CountryCode | translate: 'CountryCode' }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.vatNumber' | translate }}</p>
					<p class="is-value">{{ company?.VatNumber }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.name' | translate }}</p>
					<p class="is-value">{{ company?.Name }}</p>
				</div>
			</div>
		</div>

		<div class="is-content-section">
			<div class="is-content-section-fields">
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.addressLine1' | translate }}</p>
					<p class="is-value">{{ company?.AddressLine1 }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.addressLine2' | translate }}</p>
					<p class="is-value">{{ company?.AddressLine2 }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.addressLine3' | translate }}</p>
					<p class="is-value">{{ company?.AddressLine3 }}</p>
				</div>
			</div>
			<div class="is-content-section-fields">
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.zipCode' | translate }}</p>
					<p class="is-value">{{ company?.ZipCode }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.city' | translate }}</p>
					<p class="is-value">{{ company?.City }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.activityCode' | translate }}</p>
					<p class="is-value">{{ company?.ActivityCode }}</p>
				</div>
			</div>
		</div>

		<div class="is-content-section">
			<div class="is-content-section-fields">
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.timeZone' | translate }}</p>
					<p class="is-value">{{ getTimeZoneDisplayName(company?.TimeZone) }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.languageCode' | translate }}</p>
					<p class="is-value">{{ getLanguageDisplay(company?.LanguageCode) }}</p>
				</div>
				<div class="is-content-section-field">
					<p class="is-label">{{ 'company-details.shareCapital' | translate }}</p>
					<p class="is-value">{{ company?.ShareCapital | number: '1.2-2' }}</p>
				</div>
			</div>
		</div>
	</div>

	<div class="d-flex justify-content-end gap-1 mt-3">
		<eif-custom-button
			[text]="'button.back'"
			[color]="'neutral'"
			(action)="navigateToCompanies()">
		</eif-custom-button>

		@if (userCanEditCompanyInformation()) {
			<eif-custom-button
				[text]="'button.edit'"
				(action)="navigateToEditCompany()">
			</eif-custom-button>
		}
	</div>
</div>
